import { ApiLambdalerAuthHeaderWithRequestActorSchema } from '@eigtech/lambdaler-api-gateway-types';
import { z } from 'zod';
import { AssetTypeSchema } from '../../events/assets.js';
import { OwnerCornSchema } from '../../owner/owner.js';
export const GetOwnerUploadUrlApiSchema = {
    body: z.object({
        assetType: AssetTypeSchema,
    }),
    params: z.object({
        ownerId: OwnerCornSchema,
    }),
    headers: ApiLambdalerAuthHeaderWithRequestActorSchema,
    response: z.object({
        fields: z.record(z.string(), z.string()),
        url: z.string(),
    }),
};
export const GetOwnerUploadUrlBodySchema = GetOwnerUploadUrlApiSchema.body;
export const GetOwnerUploadUrlHeadersSchema = GetOwnerUploadUrlApiSchema.headers;
export const GetOwnerUploadUrlPathSchema = GetOwnerUploadUrlApiSchema.params;
export const GetOwnerUploadUrlRequestSchema = GetOwnerUploadUrlBodySchema.merge(GetOwnerUploadUrlHeadersSchema).merge(GetOwnerUploadUrlPathSchema);
export const GetOwnerUploadUrlResponseSchema = GetOwnerUploadUrlApiSchema.response;
